'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var sizes = require('../../../constants/sizes.js');
var Spinner_module = require('../styles/Spinner.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description A spinner for displaying loading state of a page or a section
 *
 * @component
 * @example
 * ```jsx
 * <Spinner />
 * ```
 */
const Spinner = React__namespace.forwardRef((props, ref) => {
    const { size, className, ...restProps } = props;
    const cx = reactUtils.useStyles(Spinner_module.default);
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
    });
    return (React__namespace.createElement("span", { ref: ref, "data-qa": "Spinner", className: classNames, ...restProps },
        React__namespace.createElement("svg", { className: cx('svg'), viewBox: "0 0 150 150" },
            React__namespace.createElement("circle", { className: cx('circle', 'circle-1'), cx: "75", cy: "75", r: "60" }),
            React__namespace.createElement("circle", { className: cx('circle', 'circle-2'), cx: "75", cy: "75", r: "60" }))));
});
Spinner.defaultProps = {
    size: sizes.CONTENT_SIZES.S20,
};
Spinner.displayName = 'Spinner';

exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map
